import http from '../../../../api/http'

function retrieveOnlineJobFairTotalCount(paramObj) {
    return http.post('/admin/ojf/onlineJobFair/retrieveOnlineJobFairTotalCount', paramObj)
}

function retrieveAllOnlineJobFairList(paramObj) {
    return http.post('/admin/ojf/onlineJobFair/retrieveAllOnlineJobFairPaging', paramObj)
}

function retrieveOnlineJobFair(ojfId) {
    return http.get(`/admin/ojf/onlineJobFair/retrieveOnlineJobFair?ojfId=${ojfId}`);
}

function createOnlineJobFair(paramObj) {
    return http.post('/admin/ojf/onlineJobFair/createOnlineJobFair', paramObj)
}

function updateOnlineJobFair(paramObj) {
    return http.post('/admin/ojf/onlineJobFair/updateOnlineJobFair', paramObj)
}

function deleteOnlineJobFair(paramObj) {
    return http.post('/admin/ojf/onlineJobFair/deleteOnlineJobFair', paramObj)
}

function retrieveRecruitmentHallCountByOjfId(ojfId) {
    return http.get(`/admin/ojf/recruitmentHall/retrieveRecruitmentHallCountByOjfId?ojfId=${ojfId}`);
}

function retrieveEntryCountByOjfId(ojfId) {
    return http.get(`/admin/ojf/entry/retrieveEntryCountByOjfId?ojfId=${ojfId}`);
}

export default {
    retrieveAllOnlineJobFairList,
    retrieveOnlineJobFair,
    retrieveOnlineJobFairTotalCount,
    createOnlineJobFair,
    updateOnlineJobFair,
    deleteOnlineJobFair,
    retrieveRecruitmentHallCountByOjfId,
    retrieveEntryCountByOjfId
}
